import { ShipmentEvent, SupplyChainTrackingEvent } from "../shared/interfaces";
import { DELIVERED, IN_TRANSIT, ORDERED, OUT_FOR_DELIVERY, RECEIVED_AT_ORIGIN, CONTAINERIZED, LOADED, DEPARTED, ARRIVED, UNLOADED, BOOKING_CONFIRMED, SHIPPED, IN_TRANSIT_TO_PICKUP, CARRIER_RECEIVED_SHIPMENT, DEPARTED_TERMINAL } from "../shared/strings/constants";

/**
 * Removes duplicate events based on event code.
 * Keeps the first occurrence of each event code.
 *
 * @param shipmentEvents - Array of supply chain tracking events
 * @returns Array of unique events
 */
export const dedupeEvents = (shipmentEvents: Array<SupplyChainTrackingEvent>) => {
    const seenEventCodes = new Set<string>();
    return shipmentEvents.filter(shipmentEvent => {
        if(seenEventCodes.has(shipmentEvent.eventCode)) {
            return false;
        }
        seenEventCodes.add(shipmentEvent.eventCode);
        return true;
    });
};

/**
 * Checks if a shipment event represents a progress label status.
 * Progress label statuses are key milestones in the shipment journey.
 *
 * @param shipmentEvent - The shipment event to check
 * @returns boolean indicating if the event is a progress label
 */
export const isShipmentEventProgressLabel = (shipmentEvent: ShipmentEvent) => {
    return [
        ORDERED,
        IN_TRANSIT,
        OUT_FOR_DELIVERY,
        DELIVERED,
        RECEIVED_AT_ORIGIN,
        CONTAINERIZED,
        LOADED,
        DEPARTED,
        ARRIVED,
        UNLOADED,
        BOOKING_CONFIRMED,
        SHIPPED,
        IN_TRANSIT_TO_PICKUP,
        CARRIER_RECEIVED_SHIPMENT,
        DEPARTED_TERMINAL
    ].includes(shipmentEvent.eventStatus);
};

/**
 * Sorts events by their timestamp.
 *
 * @param a - First shipment event
 * @param b - Second shipment event
 * @returns Comparison result for sorting
 */
export const eventTimeSorter = (a: ShipmentEvent, b: ShipmentEvent) => {
    return b.eventTime - a.eventTime;
};
